import {RouterModule, Routes} from '@angular/router';
import {NgModule} from '@angular/core';
import {LoginComponent} from './modules/login/login.component';
import {ForgotPasswordComponent} from './modules/forgot-password/forgot-password.component';
import {SetPasswordComponent} from './modules/set-password/set-password.component';
import {LoggedInGuard} from './guards/logged-in.guard';
import {DashboardComponent} from './modules/dashboard/dashboard.component';
import {NotLoggedInGuard} from './guards/not-logged-in.guard';
import {SignoutComponent} from './modules/signout/signout.component';
import { AccountConfirmComponent } from './modules/account/account-confirm/account-confirm.component';
import {AccountDeletedComponent} from "./modules/account/deletion/account-deleted/account-deleted.component";
import {TwoFactorAuthComponent} from "./modules/two-factor-auth/two-factor-auth.component";

const routes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent, canActivate: [NotLoggedInGuard] },
  { path: 'reset-password', component: ForgotPasswordComponent },
  { path: 'two-factor', component: TwoFactorAuthComponent, canActivate: [NotLoggedInGuard] },
  { path: 'set-password/:passwordResetCode', component: SetPasswordComponent },
  { path: 'dashboard', component: DashboardComponent, canActivate: [LoggedInGuard] },
  { path: 'signout', component: SignoutComponent, canActivate: [LoggedInGuard]},
  { path: 'account-confirm/:culture/:confirmationCode', component: AccountConfirmComponent },
  { path: 'account-confirm/:culture', redirectTo: '' },
  {
    path: 'account-deletion/:culture/:code',
    component: AccountDeletedComponent,
    canActivate: [LoggedInGuard],
    data: { returnAfterLogin: true }
  },
  { path: '**', redirectTo: '/login'},
  ];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }

